/**
 * 港股买卖盘
 */
import React, { useEffect, useState } from "react"
import { getStockMMPDataSSE } from "../../../modules/quote/web"
import { store } from "../../page/hk/store"
import { quotedata } from "../quotedata"
import { FormateArrTY, QuoteTradeRecord } from "../utils"
import "./index.less"

export function TradeList(props: { quotedata: quotedata }) {
  const [tradeData, setTradeData] = useState<any>({})
  const loadMore = () => {
    location.href = "/quote/stockmore_new.html?id=" + props.quotedata.code + "&mk=" + props.quotedata.market
  }

  useEffect(() => {
    let sse = getStockMMPDataSSE(props.quotedata.quotecode,(data:any)=>setTradeData(data))
    return () => {
      try {
        sse.close()
      } catch (error) {}
    }
  }, [])

  return (
    <>
      {store.QuoteTradeType == QuoteTradeRecord.十档行情 && (
        <div className="mmp-list">
          <dl>
            <dt>
              卖<br />盘
            </dt>
            <dd>
              {tradeData?.Sell?.length > 0 && (
                <ul>
                  <li>
                    <div>{FormateArrTY(tradeData.Sell[0], 0, ".")}</div>&nbsp;
                    <div>{FormateArrTY(tradeData.Sell[0], 1, ".")}</div>&nbsp;
                  </li>
                  <li>
                    <div>{FormateArrTY(tradeData.Sell[1], 0, ".")}</div>&nbsp;
                    <div>{FormateArrTY(tradeData.Sell[1], 1, ".")}</div>&nbsp;
                  </li>
                </ul>
              )}
            </dd>
          </dl>
          <dl>
            <dt>
              买<br />盘
            </dt>
            <dd>
              {tradeData?.Buy?.length > 0 && (
                <ul>
                  <li>
                    <div>{FormateArrTY(tradeData.Buy[0], 0, ".")}</div>&nbsp;
                    <div>{FormateArrTY(tradeData.Buy[0], 1, ".")}</div>&nbsp;
                  </li>
                  <li>
                    <div>{FormateArrTY(tradeData.Buy[1], 0, ".")}</div>&nbsp;
                    <div>{FormateArrTY(tradeData.Buy[1], 1, ".")}</div>&nbsp;
                  </li>
                </ul>
              )}
            </dd>
          </dl>
          <dl onClick={loadMore}>
            <dt>
              更<br />多
            </dt>
          </dl>
        </div>
      )}
    </>
  )
}
